import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {SaleInvoiceModel} from '../../../api/entity/saleInvoice.model';

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceRepository extends AbstractRepositoryV2<SaleInvoiceModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('SaleInvoice', serviceElementsFactory, injector);
    }
}
